/**
 * Monte view switcher (mobile)
 *
 * Permite alternar entre vista 1 columna y 2 columnas en la pagina de
 * coleccion en mobile. Cambia las clases del product grid.
 */

(function () {
  const STORAGE_KEY = 'monte_view_mobile';

  function getGrid() {
    return document.querySelector('#product-grid, .product-grid');
  }

  function applyView(view) {
    const grid = getGrid();
    if (!grid) return;
    if (view === '1') {
      grid.classList.remove('grid--2-col-tablet-down');
      grid.classList.add('grid--1-col');
      grid.classList.add('monte-view--1');
      grid.classList.remove('monte-view--2');
    } else {
      grid.classList.add('grid--2-col-tablet-down');
      grid.classList.remove('grid--1-col');
      grid.classList.add('monte-view--2');
      grid.classList.remove('monte-view--1');
    }
    document.querySelectorAll('.monte-view-switcher__btn').forEach((b) => {
      b.classList.toggle('is-active', b.dataset.view === view);
    });
    try { localStorage.setItem(STORAGE_KEY, view); } catch (e) {}
  }

  function init() {
    const buttons = document.querySelectorAll('.monte-view-switcher__btn');
    if (!buttons.length) return;
    let stored = '2';
    try { stored = localStorage.getItem(STORAGE_KEY) || '2'; } catch (e) {}
    applyView(stored);
    buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        applyView(btn.dataset.view);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
